import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { requestCommitmentStatuses } from 'legacy/lut/features/partner360/commitment'
import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import {
  selectFinancialYear,
  selectPartnerAccess,
  selectPartnerId,
  selectProgramType,
} from 'legacy/lut/features/partner360/configuration'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'

interface IUseKeyInitiativesEditor {
  entryId?: number
  partnerId?: string
  fYear?: number
  programType?: ProgramTypes
  isCommercial?: boolean
}

export const useKeyInitiativesEditor = ({
  partnerId: partnerIdOverride,
  fYear: fYearOverride,
  programType: programTypeOverride,
  isCommercial: isCommercialOverride,
}: IUseKeyInitiativesEditor) => {
  const dispatch = useAppDispatch()
  const ownerId = useSelector(selectAppOwnerId)

  const selectedProgramType = useSelector(selectProgramType)
  const selectedFYear = useSelector(selectFinancialYear)
  const selectedPartnerId = useSelector(selectPartnerId)
  const { isCommercial: selectedIsCommercial } = useSelector(selectPartnerAccess)

  const programType = programTypeOverride ?? selectedProgramType
  const fYear = fYearOverride ?? selectedFYear
  const partnerId = partnerIdOverride ?? selectedPartnerId
  const isCommercial = isCommercialOverride ?? selectedIsCommercial

  const recalculateCompleteness = useCallback(() => {
    const parameters = {
      partnerId,
      fYear,
    }

    const recalculation = dispatch(requestRecalculateCompleteness(parameters))
    dispatch(requestCommitmentStatuses(parameters))

    return recalculation
  }, [dispatch, partnerId, fYear])

  return {
    isCommercial,
    recalculateCompleteness,
    ownerId,
    fYear,
    programType,
    partnerId,
  }
}
